import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit-small",
  "use": "edit-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"edit-small\">\n  <path d=\"M11.634 2.065c-.701-.491-1.433-.901-2.186-1.236l-6.991 9.984v4.358l4.095-1.49 6.991-9.984c-.572-.594-1.208-1.141-1.909-1.632zm-1.855.034c.439.234.867.495 1.281.785.414.29.807.603 1.176.936l-1.438 2.054-2.458-1.72 1.439-2.055zm-3.865 10.75l-2.457.894v-2.615l4.31-6.155.819.573-3.939 5.626.819.574L9.405 6.12l.819.573-4.31 6.156z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol